import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { BaseComponent } from '../../../../modules/tcm-core.module';
import { NoahSessionShortInfoViewModel } from '../../../../models/noah-sessions/noah-session-short-info-view-model';
import { NoahSessionShortInfoRequest } from '../../../../models/noah-sessions';
import { SecureBaseComponentContext } from '../../../../modules/tcm-common/services/secure-base-component-context.service';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { merge } from 'rxjs/internal/observable/merge';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { Subscription } from 'rxjs/internal/Subscription';
import { NoahDataService } from '../../../../services/noah-data.service';
import { AuthService } from '../../../../services';
import { DOCUMENT } from '@angular/common';
import { throttleTime, tap, timeout } from 'rxjs/operators';
import { Task } from '../../../../helpers/task';
import { BaseComponent } from '../../../../modules/tcm-core.module/components/base-component/base-component.component';

@Component({
    selector: 'noah-short-info',
    templateUrl: './noah-short-info.component.html',
    styleUrls: ['./noah-short-info.component.scss'],
    standalone: false
})
export class NoahShortInfoComponent
    extends BaseComponent<NoahSessionShortInfoRequest, NoahSessionShortInfoViewModel> {
    public missingRightData: boolean;
    public missingLeftData: boolean;
    private updateSubscription: Subscription;
    private userInteractionSubscription: Subscription;

    constructor(protected override componentContext: SecureBaseComponentContext,
        protected override route: ActivatedRoute,
        private noahDataService: NoahDataService,
        private authService: AuthService,
        @Inject(DOCUMENT) private document: Document) {
        super(componentContext, route);

        this.actionName = 'NoahSessions/GetShortInfo'; 
        this.updateSubscription = this.componentContext.broadcastService
            .getEvents(BroadCastEvents.SalesOrderLineChanged,
                BroadCastEvents.SalesOrderLinesStatusChanged,
                BroadCastEvents.SerializedItemChanged)
            .subscribe(e => {
                this.refresh();
            });
    }

    protected createRequestModel(): NoahSessionShortInfoRequest {
        var request = {} as NoahSessionShortInfoRequest;

        return request;
    }

    protected override onViewModelChanged() {
        super.onViewModelChanged();

        this.missingRightData = !this.viewModel || !this.viewModel.rightSession;
        this.missingLeftData = !this.viewModel || !this.viewModel.leftSession;
    }

    override async ngAfterViewInit() {
        super.ngAfterViewInit();

        await Task.delay(10000, this.componentCancellationTokenSource.promise());

        // Subscribe to user interaction events
        const eventStreams = ['mousemove', 'mousedown', 'keydown', 'focus'].map((ev) => fromEvent(this.document, ev));

        this.userInteractionSubscription = merge(...eventStreams)
            .pipe(
                throttleTime(10000),
                tap(_ => this.checkSessionChanges()))
            .subscribe();
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.updateSubscription.unsubscribe();

        if (this.userInteractionSubscription) {
            this.userInteractionSubscription.unsubscribe();
        }
    }

    private async checkSessionChanges() {
        try {

            if (!this.authService.currentUserValue)
                return;

            var request = this.requestModel;

            request.leftActionDataId = this.viewModel && this.viewModel.leftSession && this.viewModel.leftSession.actionDataId;
            request.leftActionDataVersion = this.viewModel && this.viewModel.leftSession && this.viewModel.leftSession.version;
            request.rightActionDataId = this.viewModel && this.viewModel.rightSession && this.viewModel.rightSession.actionDataId;
            request.rightActionDataVersion = this.viewModel && this.viewModel.rightSession && this.viewModel.rightSession.version;


            var changed = await this.noahDataService.checkNoahActionChangedAsync(request, this.componentCancellationTokenSource.promise());

            if (changed) {
                this.refresh();
                this.componentContext.broadcastService.next({ name: BroadCastEvents.NoahSessionUpdated });
                this.componentContext.broadcastService.next({ name: BroadCastEvents.AppointmentHaNeededChanged });
            }
        }
        catch (e) {
            console.error(e);
        }
    }
}
